import { createStore } from 'vuex'

import user from './modules/user'
import common from './modules/common'

import getters from './getters'

const store = createStore({
    modules: {
        user,
        common
    },
    getters,
    mutations: {
        clearAllData(state) {
            state.user.token =  {}
        }
    }
})
export default store
